import { render, staticRenderFns } from "./SurgeryFilter.vue?vue&type=template&id=445cd566&"
import script from "./SurgeryFilter.vue?vue&type=script&lang=js&"
export * from "./SurgeryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports